import {initGA} from "./GAUtils";
import {optInMixPanel} from "./MixPanelUtils";

// Booting gtag.js and flushing Mixpanel's queued batch costs ~60ms of main-thread time on a
// mid-tier phone. Called straight from the cookie banner's click handler it blocks the paint
// that dismisses the banner, which is what put the homepage's INP over Google's 200ms
// threshold; called from App's mount effect it lands in the load-time long tasks instead.
// Neither case needs the trackers up synchronously, only soon.
function afterPaint(run: () => void): void {
  if (typeof window === "undefined") {
    run();
    return;
  }

  if (typeof window.requestIdleCallback === "function") {
    // the timeout bounds the wait on a page that never goes idle
    window.requestIdleCallback(run, {timeout: 2000});
    return;
  }

  // Safari < 16.4 has no idle callback; a timeout from inside a frame is the equivalent yield
  window.requestAnimationFrame(() => window.setTimeout(run, 0));
}

export function startAnalytics(): void {
  afterPaint(() => {
    initGA();
    optInMixPanel();
  });
}
